var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class FrontPage extends Component {
    constructor() {
        super('FrontPage', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            // Shuffle carousel items
            $('.home .carousel').each((carousel) => {
                const items = carousel.find('.carousel-item').removeClass('active');
                let itemsArray = Array.from(items);
                for (let index = itemsArray.length - 1; index > 0; index--) {
                    let j = Math.floor(Math.random() * (index + 1));
                    [itemsArray[index], itemsArray[j]] = [itemsArray[j], itemsArray[index]];
                    items.eq(index).remove();
                }
                itemsArray.forEach(t => carousel.find('.carousel-inner').append($(t)));
                carousel.find('.carousel-item').first().addClass('active');
            });
            $('.home main').removeClass('opacity-0');
            $(window).on('resize', () => {
                if ($('.home h1 > span').width() + parseFloat($('.home h1').css('padding-left')) * 2 > $(window).width()) {
                    $('.home h1').removeClass('fs-large').addClass('fs-medium');
                }
                if ($('.home h1').height() > $(window).height()) {
                    $('.home h1').removeClass('fs-medium').addClass('fs-large');
                }
            });
            $('.home').on('click', (event) => {
                if ($(event.target).get(0).tagName == 'A')
                    return;
                window.location.href = $('.home .link-projects').attr('href');
            });
            this.success();
        });
    }
}
